import { RouteStatus } from "@/constants/trip";

export const TripMonitorHiddenRouteStatuses = [RouteStatus.cancelled, RouteStatus.completed];
